(function () {
  'use strict';

  angular
    .module('airport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('airport', {
        sticky: true,
        url: '/airport',
        views: {
            'airportView': {
            	  templateUrl: 'airport/views/airport.tpl.html',
                  controller: 'AirportCtrl',
                  controllerAs: 'airport'
            }
        }
    });
  }
}());


